import appendImageUrlFromAPI from "@/utils/appendImageUrlFromAPI";
import { Card, createStyles, Divider, Grid, Group, Skeleton, Text, Title, } from "@mantine/core";
import { IconCalendar } from "@tabler/icons-react";
import { motion } from "framer-motion";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import Container from "../Layout/Container/Container";
import useStyles from "./styles";

function NewCardProSub({ item, isLoading = false }) {
  const { classes } = useStyles();
  const { locale } = useRouter();

  return (
    <motion.div
      whileHover={{ scale: 1.02 }} 
    >
    <Container shadow="sm"/*  bg="pink" */ p={0} radius="md" sx={{ height: "100%" }}>
      <Link scroll={false} href={`/tin-tuc/${item?.slug}` || "#"}>
        <a>
          <Skeleton visible={isLoading}>
            <Card
              className={classes.customCard}
              padding="md"
              style={{backgroundImage: `url(${appendImageUrlFromAPI({src: item?.picture, size: "m" })})`, }}
            >
              <div className={classes.cardContent}>
                <Title order={1} size="sm" lineClamp={2}>{item?.title}</Title>
                <Divider/>
                <Text size="sm">
                    {new Date(item?.date_updated).toLocaleDateString(locale, {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                    })}
                </Text>
              </div>
            </Card>
          </Skeleton>
        </a>
      </Link>
    </Container>
    </motion.div>
  );
}

export default NewCardProSub;
